import { ROLES, isBranchAdmin } from '@bb/users';
import React, { useEffect, useMemo } from 'react';

// @TODO: Migrate to `assets/components/PreviewButton`
const PreviewButton = ({
  listing,
  listingId,
  auth,
  ModalService,
  errorReporter,
  $rootScope,
}: any) => {
  useEffect(() => {
    if (listing) return;
    if (!listingId)
      errorReporter.error(
        'you must provide a listingId if there is no listing provided to the preview button',
      );
  }, []);

  const openPreview = () => {
    $rootScope.$evalAsync(() => {
      ModalService.openPreviewModal(listing);
    });
  };

  const isAuthForLocation = useMemo(() => {
    if (!auth) return false;

    const listingLocations = Array.from(
      new Set([listing.location?.toString(), ...(listing.locations || [])]),
    ).filter(Boolean);

    const userAuthorizedLocations = Array.from(
      new Set([auth.location, ...(auth.locations || [])]),
    ).filter(Boolean);

    return listingLocations.some((location: string) =>
      userAuthorizedLocations.includes(location),
    );
  }, [auth, listing]);

  if (!auth) return null;

  return (
    <>
      {!listing.isDeleted &&
        listing.org?.features?.includes('APPOINTMENT') &&
        (listing.org === auth?.org?.id || listing.org.id === auth?.org?.id) &&
        (auth.roles[auth.role] >= ROLES.GLOBAL_ADMIN ||
          (isBranchAdmin(auth) && isAuthForLocation)) && (
          <button
            className="btn btn-default pull-right margin-right hidden-xs"
            onClick={openPreview}
          >
            <i className="pe-7s-look fat" />
          </button>
        )}
    </>
  );
};

export default PreviewButton;
